import { useState } from "react";
import { FileText } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "./ui/dropdown-menu";

export const fillTemplate = (text, vars) => (text || "").replace(/\{(first_name|next_appointment|clinic_name)\}/g, (_, k) => vars[k] || "");

export function TemplatePicker({ vars, onPick, testId = "template-picker", label = "Templates", size = "sm" }) {
  const [items, setItems] = useState(null);
  const load = (open) => { if (open && !items) api.get("/msg-templates").then((r) => setItems(r.data)).catch(() => setItems([])); };
  const groups = (items || []).reduce((g, t) => ({ ...g, [t.category || "General"]: [...(g[t.category || "General"] || []), t] }), {});
  return (
    <DropdownMenu onOpenChange={load}>
      <DropdownMenuTrigger asChild>
        <Button type="button" size={size} variant="outline" className="rounded-full" data-testid={testId}><FileText className="h-4 w-4 mr-1" />{label}</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="max-h-80 overflow-y-auto w-64" data-testid={`${testId}-menu`}>
        {items && !items.length && <div className="p-3 text-xs text-muted-foreground">No templates yet. Add them in Settings → Templates.</div>}
        {!items && <div className="p-3 text-xs text-muted-foreground">Loading…</div>}
        {Object.entries(groups).map(([cat, list]) => (
          <div key={cat}>
            <DropdownMenuLabel className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">{cat}</DropdownMenuLabel>
            {list.map((t) => (
              <DropdownMenuItem key={t.id} data-testid={`${testId}-item-${t.id}`}
                onSelect={() => onPick({ subject: fillTemplate(t.subject, vars), body: fillTemplate(t.body, vars) })}>{t.name}</DropdownMenuItem>
            ))}
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
